module.exports = __webpack_public_path__ + "img/error-msg.8c98bbe5.png";